"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _rjsConfigUtils = require("../common/rjs-config-utils");

var _experiment = require("../common/experiment");

var _joinURL = _interopRequireDefault(require("../common/joinURL.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(versions, local, serviceTopology, editorModel) {
  var wixUiSantaStaticOverrideExp = 'allowWixUiSantaStaticOverride';
  var langsLocation = (0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'santa-langs', 'http://static.parastorage.com/services/santa-langs/1.194.0');
  var languageCode = editorModel && editorModel.languageCode || 'en';
  var langsUrl = (0, _joinURL["default"])(langsLocation, "resources/santa-editor/bundles/_generated/santa_editor_".concat(languageCode, ".json"));

  if (langsUrl.indexOf('http:') === 0) {
    langsUrl = [langsUrl, langsUrl.replace(/http/, 'https')];
  }

  var tpaGfppDataUrl = (0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'tpa-gfpp-data', 'http://static.parastorage.com/services/tpa-gfpp-data/1.5.0');
  var platformAppConfigurationUrl = (0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'js-platform-apps-configuration', 'https://static.parastorage.com/services/js-platform-apps-configuration/1.7.0');
  var mmgrBaseUrl = serviceTopology ? serviceTopology.mediaManagerFrameUrl.replace(/\.js$/, '') : 'http://media-manager.wix.com/media-frame.min';
  var scriptsDomainUrl = serviceTopology && serviceTopology.scriptsDomainUrl || 'http://static.parastorage.com/';
  /**
   *  @type {function(pkg:string, path:string)}
   */

  var _unpkg = _rjsConfigUtils.unpkgOrNode.bind(null, versions, local);
  /**
   *  @type {function(pkg:string, min:string, debug:string)}
   */


  var _unpkgObj = _rjsConfigUtils.unpkgOrNodeObj.bind(null, versions, local);

  var ckeditor = _joinURL["default"].bind(null, scriptsDomainUrl, 'services', 'ck-editor');

  return {
    // artifacts,
    marketplace: (0, _joinURL["default"])((0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'marketplace-editor-container'), 'add-panel-marketplace.bundle.min'),
    marketplaceStaticsUrl: (0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'marketplace-component'),
    manageAppsStaticsUrl: (0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'manage-installed-apps'),
    ckeditor: ckeditor('1.223.0/ckeditor'),
    langs: langsUrl,
    mediaFrame: mmgrBaseUrl,
    facebook: ['//connect.facebook.net/en_US/all', _unpkg('santa-external-modules', 'facebook/facebook.min')],
    codeEditor: (0, _joinURL["default"])((0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'wix-code-code-editor'), 'static/js'),
    '@wix/wix-code-classic-editor': _unpkg('@wix/wix-code-classic-editor', 'dist/index'),
    tpaGfppData: (0, _joinURL["default"])(tpaGfppDataUrl, 'data/tpa-gfpp-data.min'),
    'js-platform-apps-configuration-editor': (0, _joinURL["default"])(platformAppConfigurationUrl, 'platform-apps-editor.min'),
    'js-platform-add-panel': (0, _joinURL["default"])(platformAppConfigurationUrl, 'platform-add-panel.min'),
    pms: _unpkg('santa-external-modules', 'pms/PMS'),
    plugins: 'js/plugins/bundle/plugins.bundle',
    // third party
    color: _unpkg('santa-external-modules', 'color-convert/0.2.0/color.min'),
    speakingurl: _unpkg('santa-external-modules', 'speakingurl/7.0.0/speakingurl.min'),
    keyboardMaster: _unpkgObj('santa-external-modules', 'keymaster/1.6.3/keymaster.min', 'keymaster/1.6.3/keymaster'),
    // no minified versions on unpkg
    aviary: _unpkg('santa-external-modules', 'aviary/3.1.0.243/feather'),
    'redux-immutablejs': _unpkg('santa-external-modules', 'redux-immutablejs/0.0.7/redux-immutablejs.min'),
    TweenMax: _unpkgObj('gsap', 'src/minified/TweenMax.min', 'src/uncompressed/TweenMax'),
    //bundle
    TweenLite: _unpkgObj('gsap', 'src/minified/TweenMax.min', 'src/uncompressed/TweenMax'),
    TimelineMax: _unpkgObj('gsap', 'src/minified/TweenMax.min', 'src/uncompressed/TweenMax'),
    ScrollToPlugin: _unpkgObj('gsap', 'src/minified/plugins/ScrollToPlugin.min', 'src/uncompressed/plugins/ScrollToPlugin'),
    //bundle
    DrawSVGPlugin: _unpkgObj('santa-external-modules', 'tweenmax-plugins/1.19.0/DrawSVGPlugin.min', 'tweenmax-plugins/1.19.0/DrawSVGPlugin'),
    MorphSVGPlugin: _unpkgObj('santa-external-modules', 'tweenmax-plugins/1.19.0/MorphSVGPlugin.min', 'tweenmax-plugins/1.19.0/MorphSVGPlugin'),
    Draggable: _unpkgObj('gsap', 'src/minified/utils/Draggable.min', 'src/uncompressed/utils/Draggable'),
    // NOTE: there is no .min version for tslib package on CDN https://static.parastorage.com/unpkg/tslib@1.9.3/tslib.js consider a PR with fix
    tslib: _unpkg('tslib', 'tslib'),
    // unpkg
    'ab-translate': _unpkgObj('ab-translate', 'dist/statics/abTranslate-runtime.bundle.min', 'dist/statics/abTranslate-runtime.bundle'),
    lodash: _unpkg('lodash', 'lodash.min'),
    zepto: _unpkg('zepto', 'dist/zepto.min'),
    react: _unpkgObj('react', 'umd/react.production.min', 'umd/react.development'),
    'react-dom': _unpkgObj('react-dom', 'umd/react-dom.production.min', 'umd/react-dom.development'),
    'react-dom/test-utils': _unpkg('react-dom', 'umd/react-dom-test-utils.development'),
    'react-addons-linked-state-mixin': _unpkg('react-addons-linked-state-mixin', 'react-addons-linked-state-mixin'),
    'react-addons-pure-render-mixin': _unpkg('react-addons-pure-render-mixin', 'react-addons-pure-render-mixin'),
    'react-transition-group': _unpkgObj('react-transition-group', 'dist/react-transition-group.min', 'dist/react-transition-group'),
    'prop-types': _unpkgObj('prop-types', 'prop-types.min', 'prop-types'),
    'create-react-class': _unpkgObj('create-react-class', 'create-react-class.min', 'create-react-class'),
    'react-dom-factories': _unpkg('react-dom-factories', 'index'),
    immutable: _unpkgObj('immutable', 'dist/immutable.min', 'dist/immutable'),
    wixReactDealerViewer: (0, _joinURL["default"])((0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'react-dealer-viewer'), 'dealer-react-viewer.bundle.min'),
    advancedSeoClient: (0, _joinURL["default"])((0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'advanced-seo-client'), 'app.bundle.min'),
    wixDealerClientApi: (0, _joinURL["default"])((0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'dealer-client-api'), 'dealer-api.bundle.min'),
    wixDiscoveryLoader: _unpkg('@wix/discovery-loader', 'dist/statics/discovery-loader.bundle.min'),
    pmrpc: _unpkg('pm-rpc', 'build/pm-rpc.min'),
    'wix-base-ui': _unpkg('wix-base-ui', 'dist/base-ui'),
    'santa-renderer': _unpkg('santa-renderer', 'dist/santa-renderer'),
    'host-worker-init': _unpkg('santa-host-platform-services', 'dist/host-worker-init'),
    'santa-renderer-wixcode-extension': _unpkg('santa-renderer', 'dist/santa-renderer-wixcode-extension'),
    'santa-base-ui': _unpkg('santa-base-ui', 'dist/santa-base-ui'),
    'wix-ui-santa': (0, _experiment.isOpen)(wixUiSantaStaticOverrideExp, {
      editorModel: editorModel
    }) ? (0, _rjsConfigUtils.scriptLocation)(serviceTopology, 'wix-ui-santa') : _unpkg('wix-ui-santa', 'dist/statics'),
    'stylable-panel': _unpkg('@wixc3/stylable-panel', 'dist/stylable-panel'),
    'stylable-panel-drivers': _unpkg('@wixc3/stylable-panel-drivers', 'dist/stylable-panel-drivers'),
    'stylable-santa-flatten': _unpkg('stylable-santa-flatten', 'dist/main'),
    'santa-components': _unpkgObj('santa-components', 'dist/santa-components-infra.prod', 'dist/santa-components-infra.devel'),
    skinUtils: _unpkg('santa-skin-utils', 'dist/skin-utils'),
    mobx: _unpkgObj('mobx', 'lib/mobx.umd.min', 'lib/mobx.umd'),
    'mobx-react': _unpkgObj('mobx-react', 'index.min', 'index'),
    wixRichText: _unpkgObj('wix-richtext', 'dist/bundleWixRichText', 'debug/bundleWixRichText'),
    wixmp: _unpkgObj('@wix/wixmp-sdk', 'dist/statics/wixmp-sdk.bundle.min', 'dist/statics/wixmp-sdk.bundle'),
    mediaManagerSDK: _unpkgObj('@wix/media-manager-sdk', 'dist/statics/media-manager-sdk.bundle.min', 'dist/statics/media-manager-sdk.bundle'),
    'thumbnail-generator': _unpkgObj('@wix/thumbnail-generator', 'dist/statics/thumbnail-generator.bundle.min', 'dist/statics/thumbnail-generator.bundle'),
    UserFeedbackOpener: _unpkgObj('@wix/user-feedback-opener', 'dist/statics/UserFeedbackOpener.bundle.min', 'dist/statics/UserFeedbackOpener.bundle'),
    MediaImageStudio: _unpkgObj('@wix/media-image-studio-opener', 'dist/statics/MediaImageStudio.bundle.min', 'dist/statics/MediaImageStudio.bundle'),
    videoMakerOpener: _unpkgObj('@wix/video-maker-opener', 'dist/statics/videoMakerOpener.bundle.min', 'dist/statics/videoMakerOpener.bundle'),
    wixFullstoryLoader: _unpkg('wix-fullstory-loader', 'dist/statics/app.bundle'),
    'fedops-logger': _unpkg('fedops-logger', 'dist/statics/fedops-logger-module.bundle.min'),
    vs: _unpkg('monaco-editor-core', 'dev/vs'),
    addPanelSectionsDA: _unpkg('editor-add-panel', 'dist/addPanelSectionsDA'),
    addPanelSectionsDE: _unpkg('editor-add-panel', 'dist/addPanelSectionsDE'),
    addPanelSectionsEN: _unpkg('editor-add-panel', 'dist/addPanelSectionsEN'),
    addPanelSectionsES: _unpkg('editor-add-panel', 'dist/addPanelSectionsES'),
    addPanelSectionsFR: _unpkg('editor-add-panel', 'dist/addPanelSectionsFR'),
    addPanelSectionsIT: _unpkg('editor-add-panel', 'dist/addPanelSectionsIT'),
    addPanelSectionsJA: _unpkg('editor-add-panel', 'dist/addPanelSectionsJA'),
    addPanelSectionsKO: _unpkg('editor-add-panel', 'dist/addPanelSectionsKO'),
    addPanelSectionsNL: _unpkg('editor-add-panel', 'dist/addPanelSectionsNL'),
    addPanelSectionsNO: _unpkg('editor-add-panel', 'dist/addPanelSectionsNO'),
    addPanelSectionsPL: _unpkg('editor-add-panel', 'dist/addPanelSectionsPL'),
    addPanelSectionsPT: _unpkg('editor-add-panel', 'dist/addPanelSectionsPT'),
    addPanelSectionsRU: _unpkg('editor-add-panel', 'dist/addPanelSectionsRU'),
    addPanelSectionsSV: _unpkg('editor-add-panel', 'dist/addPanelSectionsSV'),
    addPanelSectionsTR: _unpkg('editor-add-panel', 'dist/addPanelSectionsTR'),
    addPanel: _unpkg('editor-add-panel', 'dist/addPanel'),
    coreMultilingual: _unpkg('santa-multilingual', 'dist/languages'),
    'santa-core-utils': _unpkg('santa-core-utils', 'dist/coreUtils'),
    'santa-editor-utils': _unpkg('santa-editor-utils', 'dist/santa-editor-utils'),
    'santa-editor-comp-panels': _unpkg('santa-editor-comp-panels', 'dist/santa-editor-comp-panels'),
    'santa-editor-symbols': _unpkg('santa-editor-symbols', 'dist/santa-editor-symbols'),
    'santa-welcome-screen': _unpkg('santa-welcome-screen', 'dist/santa-welcome-screen'),
    warmupUtilsLib: _unpkg('santa-core-utils', 'dist/warmupUtils'),
    tweenEngine: _unpkg('santa-core-utils', 'dist/tweenEngine'),
    platformUtils: _unpkg('santa-platform-utils', 'dist/platformUtils-bundle'),
    reduxLibs: _unpkg('redux-libs', 'dist/redux-libs'),
    'image-client-api': _unpkg('image-client-api', 'dist/imageClientApi'),
    imageClientSDK: _unpkg('image-client-api', 'dist/imageClientSDK'),
    'media-manager-api': _unpkg('media-manager-api', 'dist/media-manager-api'),
    wixImmutable: _unpkg('santa-core-utils', 'dist/wixImmutable'),
    'ag-grid': _unpkgObj('ag-grid', 'dist/ag-grid.min', 'dist/ag-grid'),
    'wix-code-stack-parser': _unpkgObj('wix-code-stack-parser', 'dist/wix-code-stack-parser.min', 'dist/wix-code-stack-parser'),
    'app-studio-code-parser': _unpkg('app-studio-code-parser', 'dist/app-studio-code-parser'),
    platformEvents: _unpkgObj('platform-editor-sdk', 'lib/platformEvents.min', 'lib/platformEvents'),
    qaAutomation: _unpkg('wix-santa', 'dist/testkit'),
    'wix-code-ws-listener': _unpkgObj('wix-code-ws-listener', 'dist/wix-code-ws-listener.min', 'dist/wix-code-ws-listener'),
    'wix-json-schema-utils': _unpkg('wix-json-schema-utils', 'dist/wix-json-schema-utils'),
    // ------------- TESTING -------------------------------------------------------------------
    jasmine: _unpkg('santa-external-modules', 'jasmine/2.1.3/jasmine'),
    'jasmine-html': _unpkg('santa-external-modules', 'jasmine/2.1.3/jasmine-html'),
    'jasmine-boot': _unpkg('santa-external-modules', 'jasmine/2.1.3/jasmine-boot'),
    'stylable-panel-drivers-test-kit': _unpkg('@wixc3/stylable-panel-drivers-test-kit', 'dist/stylable-panel-drivers-test-kit'),
    // ------------- DEVELOPMENT ---------------------------------------------------------------
    ReactProxy: _unpkg('santa-external-modules', 'react-proxy/ReactProxy'),
    io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
    hot: '../node_modules/santa-utils/common/hot/listener',
    //only used in dev, so no unpkg
    patcher: '../node_modules/santa-utils/common/hot/patcher' //only used in dev, so no unpkg

  };
}
//# sourceMappingURL=get-rjs-config.js.map